/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Person } from '../models/Person';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PersonService {
    /**
     * Get a person
     * @param id The id of person to get or delete
     * @param workspaceId Workspace ID is required in every request
     * @returns Person Successfully retrieved person
     * @throws ApiError
     */
    public static getPerson(
        id: string,
        workspaceId: string,
    ): CancelablePromise<Person> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/person/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Person not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of persons
     * @param workspaceId The workspace_id of person to get or delete
     * @param requestBody
     * @param limit Limit of objects to get
     * @param offset skip number of objects to get in list
     * @param email Filter by email address.
     * @param firstName Filter by first name.
     * @param lastName Filter by last name.
     * @param name Filter by full name.
     * @param phone Filter by phone number.
     * @param countryCode Filter by country code.
     * @returns Person Successfully retrieved person list
     * @throws ApiError
     */
    public static postPersonList(
        workspaceId: string,
        requestBody: {
            start_date: string;
            end_date: string;
            type: string;
            /**
             * Only people whose first conversion is inside the range.
             */
            only_new?: boolean;
        },
        limit?: number,
        offset?: number,
        email?: string,
        firstName?: string,
        lastName?: string,
        name?: string,
        phone?: string,
        countryCode?: string,
    ): CancelablePromise<Person> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/person/list',
            query: {
                'workspace_id': workspaceId,
                'limit': limit,
                'offset': offset,
                'email': email,
                'first_name': firstName,
                'last_name': lastName,
                'name': name,
                'phone': phone,
                'country_code': countryCode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `No person found`,
                500: `Internal server error`,
            },
        });
    }
}
